import { useState } from 'react';
import {
  LifetimeEntranceLimitType,
  lifetimeEntranceLimitTypeOptions,
  startEditorText,
} from './EntranceLimitForm.constants';
import { StyledRadioList, StyledFormField } from './EntranceLimitForm.styled';
import { EntranceLimitInput } from './EntranceLimitInput';

type LifetimeLimitInputProps = {
  onLifetimeLimitUpdate: (lifetimeLimit: number | null) => void;
  lifetimeLimit: number | null;
  error?: string;
  isReadOnly?: boolean;
};

export const LifetimeLimitInput = (props: LifetimeLimitInputProps) => {
  let initialLimitType = LifetimeEntranceLimitType.unlimited;
  if (props.lifetimeLimit) {
    initialLimitType =
      props.lifetimeLimit === 1 ? LifetimeEntranceLimitType.one : LifetimeEntranceLimitType.custom;
  }
  const [lifetimeLimitType, setLifetimeLimitType] = useState(initialLimitType);

  const handleTypeSelect = (type: LifetimeEntranceLimitType) => {
    setLifetimeLimitType(type);
    if (type === LifetimeEntranceLimitType.one) {
      props.onLifetimeLimitUpdate(1);
    } else {
      props.onLifetimeLimitUpdate(null);
    }
  };

  return (
    <StyledFormField
      labelText={startEditorText.lifetimeHeading}
      descriptionText={startEditorText.lifetimeDescription}
      hasError={!!props.error}
      errorText={props.error}
    >
      <StyledRadioList
        onSelect={handleTypeSelect}
        options={lifetimeEntranceLimitTypeOptions.map((opt) => ({
          ...opt,
          isDisabled: props.isReadOnly,
        }))}
        value={lifetimeLimitType}
        name="lifetime-entrance-limit-type-radios"
      />
      {lifetimeLimitType === LifetimeEntranceLimitType.custom && (
        <EntranceLimitInput
          inputId="lifetime-limit-input"
          testId="lifetime-limit-input"
          onChange={props.onLifetimeLimitUpdate}
          value={props.lifetimeLimit}
          isDisabled={props.isReadOnly}
        />
      )}
    </StyledFormField>
  );
};
